import React, { useMemo } from "react";
import { Table } from "rsuite";

import { getFormattedTime } from "utils/helpers";
import m from "definedMessages";
import CommonTable from "components/Payments/CommonPaymentsTable";
import * as S from "../styled";
import { withTranslation } from "hoc/WithTranslation";

const { Column, HeaderCell, Cell } = Table;


const PaymentsRequestTable = ({
    data = [],
    loading = false,
    handleCancelPaymentRequest,
    currencyName,

    formatMessage
}) => {

    const columns = useMemo(() => {
        const statusLabels = [
            formatMessage(m.active),
            formatMessage(m.canceled),
            formatMessage(m.passed),
            formatMessage(m.rejected),
            formatMessage(m.completed),
        ];

        const renderPaymentInfo = ({ payment_detail_info, move_to_account_name }) => {
            if (payment_detail_info) {
                return payment_detail_info;
            }

            if (move_to_account_name) {
                return formatMessage(m.transferToAccountName, {
                    account_name: <b>{move_to_account_name}</b>,
                });
            }

            return "-";
        };

        return [
            {
                id: "amount",
                label: formatMessage(m.amount),
                value: ({ amount }) => `${amount}${currencyName ? ` ${currencyName}` : ""}`,
                flexGrow: 2,
                minWidth: 150,
                width: 287,
                align: "center",
            },
            {
                id: "date",
                label: formatMessage(m.date),
                value: ({ date }) => getFormattedTime(date),
                flexGrow: 2,
                minWidth: 150,
                width: 287,
                align: "center",
            },
            {
                id: "paymentInfo",
                label: formatMessage(m.paymentInfo),
                value: renderPaymentInfo,
                flexGrow: 5,
                minWidth: 150,
                width: 718,
                align: "center",
            },
            {
                id: "status",
                label: formatMessage(m.status),
                value: ({ status }) => statusLabels[status] || status,
                flexGrow: 2,
                minWidth: 150,
                width: 287,
                align: "center",
            },
            {
                id: "service",
                label: formatMessage(m.service),
                value: ({ service }) => service,
                flexGrow: 2,
                minWidth: 150,
                width: 287,
                align: "center",
            },
        ];
    }, [currencyName, formatMessage]);

    const tableActions = useMemo(() => (
        <Column key="table__actions">
            <HeaderCell> </HeaderCell>

            <Cell>
                {(rowData) => {
                    if (rowData.status !== 0) {
                        return null;
                    }

                    return (
                        <S.StyledTableActions>
                            <S.StyledTableButton onClick={() => handleCancelPaymentRequest(rowData)}>
                                {formatMessage(m.cancel)}
                            </S.StyledTableButton>
                        </S.StyledTableActions>
                    );
                }}
            </Cell>
        </Column>
    ), [formatMessage, handleCancelPaymentRequest]);

    return (
        <CommonTable
            data={data}
            loading={loading}
            columns={columns}
            tableActions={tableActions}
        />
    );
};

export default withTranslation(PaymentsRequestTable);
